module.exports = __webpack_public_path__ + "assets/img/Payment_support.afc4c4ee.jpg";